module.exports = __webpack_public_path__ + "img/allocate-modal-no-data.300607c5.svg";